// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, flatMap, map } from 'rxjs/operators';

import { ProjectsService } from '../services/projects.service';
import {
  ProjectsActionTypes,
  LoadingProjectDetailsAction,
  CompleteLoadProjectDetailsAction,
  FailLoadProjectDetailsAction
} from './projects.actions';

@Injectable()
export class ProjectsEffects {
  @Effect()
  requestOnLoadProjectDetails$ = this.actions$.pipe(
    ofType<LoadingProjectDetailsAction>(ProjectsActionTypes.PROJECT_DETAILS_LOADING),
    flatMap(action => this.requestProjectDetails(action.payload.projectId))
  );

  constructor(private actions$: Actions, private projectsService: ProjectsService) {}

  private requestProjectDetails(
    projectId: string
  ): Observable<CompleteLoadProjectDetailsAction | FailLoadProjectDetailsAction> {
    return this.projectsService
      .get(projectId)
      .pipe(
        map(projectDetails => new CompleteLoadProjectDetailsAction(projectDetails)),
        catchError(_ => of(new FailLoadProjectDetailsAction(projectId)))
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/core/state/projects.effects.ts